import { IconButton as ButtonIcon, Chip } from '@material-ui/core';

import {
  RiCloseLine as CloseIcon,
  RiBookmarkFill,
  RiBookmarkLine,
} from '@remixicon/react';

import { createFilter, useFilters } from '@spotify/confidence-core-react';

export const FAVORITES_FILTER = createFilter<boolean>({
  id: 'favorites',
  label: 'Favorites',
  query: () => '',
  editor: ({ onClose }) => {
    onClose();
    return null;
  },
  viewer: ({ onRemove }) => (
    <Chip label="Favorites" onDelete={onRemove} deleteIcon={<CloseIcon />} />
  ),
});

export const FavoritesFilterToggle = () => {
  const { activeFilters, addFilter, removeFilter } = useFilters();
  const active = activeFilters.some(f => f.id === 'favorites');

  const handleClick = () => {
    if (active) {
      removeFilter('favorites');
    } else {
      addFilter(FAVORITES_FILTER, true);
    }
  };

  return (
    <ButtonIcon
      size="small"
      onClick={handleClick}
      aria-label="Filter favourites"
      style={
        active
          ? {
              backgroundColor: 'var(--essential-bright-accent)',
              color: '#000', // TODO(encore): use .encore-bright-accent-set class + var(--text-base)
              borderRadius: 'var(--encore-corner-radius-base)',
              width: 32,
              height: 32,
            }
          : {
              backgroundColor: 'var(--background-tinted-base)',
              borderRadius: 'var(--encore-corner-radius-base)',
              width: 32,
              height: 32,
            }
      }
    >
      {active ? <RiBookmarkFill size={16} /> : <RiBookmarkLine size={16} />}
    </ButtonIcon>
  );
};
